import { Component, Input, Output, EventEmitter, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import * as stageTypes from '../../types';
import { Observable } from 'rxjs/Observable';
import { WindowRefService } from '../../../shared/services/window-ref.service';
import { BaseFileTypeComponent } from '../base-file-type/base-file-type.component';

@Component({
  selector: 'tr-attachment',
  templateUrl: './attachment.component.html',
  //styleUrls: ['./attachment.component.scss']
})
export class AttachmentComponent extends BaseFileTypeComponent<stageTypes.IPageDef> implements AfterViewInit {

  @ViewChild('attHeaderSpan') private headerSpan: ElementRef;
  @ViewChild('attHeaderDiv') private headerDiv: ElementRef;

  private showTooltip: boolean;
  constructor(private elementRef: ElementRef, private windowRef: WindowRefService) {
    super(windowRef);
  }

  ngAfterViewInit() {
    let headerSpanWidth = this.headerSpan.nativeElement.getBoundingClientRect().width;
    let headerDivWidth = this.headerDiv.nativeElement.getBoundingClientRect().width;
    setTimeout(() => {
      this.showTooltip = (headerSpanWidth > (headerDivWidth - 30));
    }, 0);
  }
}



// WEBPACK FOOTER //
// ./src/app/stage/components/attachment/attachment.component.ts